import type { CurrencyFormat } from "@rubyplay/effw-connector";

export function extractCurrencyFormat(value: unknown): CurrencyFormat | undefined {
	if (!value || typeof value !== "object") {
		return undefined;
	}

	const candidate = value as Partial<CurrencyFormat>;

	if (
		typeof candidate.name !== "string" ||
		typeof candidate.fractionSize !== "number" ||
		!candidate.symbol ||
		typeof candidate.symbol !== "object" ||
		typeof candidate.symbol.grapheme !== "string" ||
		typeof candidate.symbol.template !== "string" ||
		typeof candidate.symbol.rtl !== "boolean" ||
		(candidate.uniqSymbol !== null && typeof candidate.uniqSymbol !== "string") ||
		typeof candidate.currencyCode !== "string" ||
		typeof candidate.decimalSeparator !== "string" ||
		typeof candidate.thousandsSeparator !== "string"
	) {
		return undefined;
	}

	return {
		name: candidate.name,
		fractionSize: candidate.fractionSize,
		symbol: {
			grapheme: candidate.symbol.grapheme,
			template: candidate.symbol.template,
			rtl: candidate.symbol.rtl,
		},
		currencyCode: candidate.currencyCode,
		uniqSymbol: candidate.uniqSymbol ?? null,
		decimalSeparator: candidate.decimalSeparator,
		thousandsSeparator: candidate.thousandsSeparator,
	};
}

export default extractCurrencyFormat;